import { Grid } from 'antd';
import { SIZES } from '../common/screen';
import { useState, useEffect } from 'react';
import { isIOS } from 'react-device-detect';
const { useBreakpoint } = Grid;

export const useDeviceSize = () => {
  const breakpoint = useBreakpoint();
  const [size, setSize] = useState<SIZES>(SIZES.PHONE);

  useEffect(() => {
    const bp = breakpoint;
    if (bp.xs || isIOS) {
      setSize(SIZES.PHONE);
      return;
    }
    if (!bp.md || isIOS) {
      setSize(SIZES.TABLET);
      return;
    }
    setSize(SIZES.DESKTOP);
  }, [breakpoint]);

  return size;
}
